export default {
  LOGIN : 'LOGIN',
  LOGIN_FAIL : 'LOGIN_USER_FAIL',
  LOGOUT : 'LOGOUT',
  ADD_PLAYER : 'ADD_PLAYER',
  DELETE_PLAYER : 'DELETE_PLAYER',
  LOAD_PLAYERS : 'LOAD_PLAYERS',
  ADD_TEAM : 'ADD_TEAM',
  DELETE_TEAM : 'DELETE_TEAM',
  LOAD_TEAMS : 'LOAD_TEAMS',
  ADD_REQUEST_PLAYER : 'ADD_REQUEST_PLAYER',
  DELETE_REQUEST_PLAYER : 'DELETE_REQUEST_PLAYER',
  LOAD_REQUEST_PLAYERS : 'LOAD_REQUEST_PLAYERS',
  LOAD_REQUEST_TEAMS : 'LOAD_REQUEST_TEAMS',
  ADD_REQUEST_TEAM : 'ADD_REQUEST_TEAM',
  DELETE_REQUEST_TEAM : 'DELETE_REQUEST_TEAM',
  MANGO_UPDATED : 'MANGO_UPDATED'
}



// WEBPACK FOOTER //
// ./src/reducers/actiontypes.js